.separator {
  border-top: 1px solid var(--tuna-palette-divider);
  margin: 4px 0;
}
